/** 
  * @class Base Class for Resources
  *   Each Slide can have multiple resources. Resources handle per resource versions/sizes etc.
  *   4 Main types of resources: images, html, fonts(todo), meta(todo) 
  *   @todo Implement todo resources above
  * @param {Object} config An options hash with settings for the Resource
  */

function SSResource(config){
  if (typeof config === 'undefined'){
    return;
  }
  this.TIMEOUT_LIMIT = 100000;
  this.RETRY_WAIT_TIME = 3000;
  
  this.config = config;
  this.resourceKey = config.resourceKey;
  this._init();
}

/**
  * @private
  * Initialization routine. This further calls inherited class implemented an initMethod
  * @todo Implement super.call once specs are implemented
  */
SSResource.prototype._init = function(){
  this._initResourceConfig();

  this.status = 'initialized';
};

/**
  * Resets resource to pre loaded state
  */
SSResource.prototype.reset = function(){
  this.status = 'initialized';
  this.retries = 0;
  if (this.suffixes){
    var suffixKey, suffix;
    for (suffixKey in this.suffixes){
      suffix = this.suffixes[suffixKey];
      suffix.status = 'initialized';
      delete(suffix.startTime);
      suffix.retries = 2;
    }
  }
};

/**
  * Initiate a load attempt on the resource
  */
SSResource.prototype.load = function(){
  this.status = 'loading';
  if (this.loadBlocked){
    return;
  }

  this.startTime = (new Date()).getTime();
  this._tryLoad();
};

/** 
  * Updates properties of the resource.
  *   An easy to use interface for SlideshareEventManager
  *   Also called when meta information for image fallback is loaded.
  * @param {Object} values A key/value pair object of values to be updated.
  */
SSResource.prototype.update = function(values){
  var key, value;
  for (key in values){
    value = values[key];
    if (this.resourceKey === 'image' && key === 'sizes'){
      this.delayedInitialize && this.delayedInitialize(value);
    } else if (this.resourceKey === 'image' && key === 'linkData'){
      // this should be happening only for fallback images. 
      // In case of background images, this is not applicable and control should not be flowing in here
      this.addLinks(value);
    } else {
      this[key] = value;
    }
  }
};

/**
  * EventHandler factory for when resource fails to load
  *   Retries this.retries number of times in case of failure before giving up
  * @private
  */
SSResource.prototype.resourceErrorInternalHandler = function(){
  var that = this;
  return function(data){
    var startTime = that.startTime;
    var elapsedTime = (new Date()).getTime() - startTime;
    var retries = that.retries;
    
    if (retries > 0 && elapsedTime < that.TIMEOUT_LIMIT){
      retries = retries - 1;
      that.update({retries : retries});
      setTimeout(function(){
        that._tryLoad();
      },that.RETRY_WAIT_TIME);
      
    } else {
      $.slideshareEventManager.trigger('resourceloadfailed', {
        index : that.config.slideIndex,
        resourceKey : that.resourceKey
      });
      
    }
  };
};

export default SSResource